module.exports = __webpack_public_path__ + "img/payanyway.b2b1c2be.png";